"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    baseRequirements: {
        "english i": 1,
        "english ii": 1,
        "english iii": 1,
        "english i for sol": 1,
        "english ii for sol": 1,
        "ib language studies a1 sl": 1,
        "eng ii for speakrs of oth lang": 1
    },
    oneAdditionalCredit: {
        "english iv": 1,
        "literary genres": 1,
        "creative writing": 1,
        "research/technical writing": 1,
        "humanities": 1,
        "public speaking iii": 1,
        "communication applications": 0.5,
        "oral interpretation iii": 1,
        "debate iii": 1,
        "adv broadcast journalism iii": 1,
        "adv journalism: newspaper iii": 1,
        "adv journalism: yearbook iii": 1,
        "business english": 1,
        "adv journalism: lit mag ii": 1,
        "adv journalism: lit mag iii": 1,
        "adv journalism: lit magazine i": 1,
        "indep study/journalism": 1,
        "journalism": 1,
        "indep study/speech": 1,
        "indep study/english": 1,
        "adv broadcast journalism i": 1,
        "ap english language and comp": 1,
        "ap english literature and comp": 1,
        "photojournalism": 1
    }
};
//# sourceMappingURL=english.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/core/english.js
// module id = 443
// module chunks = 22